import { Starter } from '../../../starters/types/StartersTypes';
import { Telemetry, TelemetryService } from '../../../ts/services/TelemetryService';
import { StarterClicked, StartersDialogClickSourceOptions, StartersDropdownConnectionTypeChanged, StarterWorkbookCreationClicked, StarterWorkbookCreationSourceOptions, TelemetryEvents } from '../TelemetryEvents';

export type StartersTelemertyOptions = Telemetry | TelemetryService;

export const starterClickedTelemetryEvent = (starter: Starter, selectedStarterIndex: number, source: StartersDialogClickSourceOptions, telemetryService?: StartersTelemertyOptions) => {
    telemetryService.sendEvent<StarterClicked>({
        connectionType: starter.connectionType.displayName,
        selectedStarterIndex,
        source,
        starterId: starter.id,
        starterName: starter.name,
        type: TelemetryEvents.StarterClicked,
    });
};

export const StartersDropdownConnectionTypeChangeddTelemetryEvent = (connectionType: string, telemetryService: Telemetry) => {
    telemetryService.sendEvent<StartersDropdownConnectionTypeChanged>({
        connectionType,
        type: TelemetryEvents.StartersDropdownConnectionTypeChanged,
    });
};

export const StarterWorkbookCreationClickedTelemtryEvent = (source: StarterWorkbookCreationSourceOptions, starter: Starter, telemetryService: StartersTelemertyOptions, withSampleData: boolean) => {
    telemetryService.sendEvent<StarterWorkbookCreationClicked>({
        connectionType: starter.connectionType.displayName,
        source,
        starterId: starter.id,
        starterName: starter.name,
        type: TelemetryEvents.StarterWorkbookCreationClicked,
        withSampleData,
    });
};
